'use client';

import {motion} from 'framer-motion';
import BookBtn from '../buttons/BookBtn/BookBtn';
import ArrowLink from '../buttons/ArrowLink/ArrowLink';
import HeroWave from './HeroWave';
import heroVariants from 'animation/heroVariants';

const HomeHero = (props) => {
  const {
    line1 = 'One Platform.',
    line2Pre = 'Every',
    line2Accent = 'Signal.',
    line3 = 'One Response.',
    text = 'Cylerian unifies security, observability, and IT operations.'
  } = props;

  return (
    <motion.section
      className='home-hero'
      initial={'hidden'}
      animate={'visible'}
      transition={{duration: 0.7, delay: 0.5, ease: 'easeInOut'}}
      variants={heroVariants}
    >
      <div className='container'>
        <h2 className='title'>
          <span className='title-line'>{line1}</span>{' '}
          <span className='title-line'>{line2Pre} <span className='title-accent'>{line2Accent}</span></span>{' '}
          <span className='title-line title-line--break'>{line3}</span>
        </h2>
        <p className='text'>{text}</p>
        <div className='buttons'>
          <BookBtn text='Book a demo' />
          <ArrowLink text={'View the platform'} url={'platform/overview/'} />
        </div>
      </div>
      <HeroWave />
    </motion.section>
  );
};

export default HomeHero;
